
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    size: {
      type: Number,
      default: 20
    },
    name: {
      type: String,
      required: true
    }
  },
  setup(props) {
    return {
      networkName: props.name,
      size: props.size
    }
  },
})
